import { r as registerInstance, h, a as Host } from './index-744b06c7.js';

const rCloseButtonCss = "r-close-button{display:block;position:relative}button{cursor:pointer;border:none;background:none;padding:0;margin:0}.button-container{width:48px;height:48px;align-content:center}.icon-close{width:16px;height:16px}.hover-state{transition:opacity 0.3s ease-in-out}@media (pointer: fine){.hover-state:hover{opacity:0.6}}";
const RCloseButtonStyle0 = rCloseButtonCss;

const RCloseButton = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.handleClose = undefined;
    }
    render() {
        return (h(Host, { key: '577b0d6563b9dbd02bdc52659719bd9b8bc93abf' }, h("button", { key: '7f984a0aaa001ed8cd2707c904ad652e20215c25', class: "close-button hover-state", "aria-label": "Close", onClick: this.handleClose }, h("div", { key: 'ad1b029f7c2042647434fd54c96ccab650d597d2', class: "button-container" }, h("img", { key: '4d7a69eb61e9b1156bd20518b1c706b8536d7d00', class: "icon-close", src: "https://assets.ritual.com/icons/close-24x24.svg", alt: "Close" })))));
    }
};
RCloseButton.style = RCloseButtonStyle0;

export { RCloseButton as r_close_button };

//# sourceMappingURL=r-close-button.entry.js.map